import http from "infra/http";
import { useMutation } from "react-query";
import { FornecedorTributacao } from 'core/features/fornecedores/typings/index';

function usePutTributacao(id?: string) {
    return useMutation(
        `/v1/fornecedor${id}/tributacao`,
        (data: FornecedorTributacao) => {

            return http.put<{ tributacaoId: string }>(
                `/v1/fornecedor/${id}/tributacao`,
                data
            );
        },
        { retry: false }
    );
}

export default usePutTributacao;
